import Button, { Props as ButtonProps } from '../../../../../../components/Button';
import RestartIcon from '../../../../../../icons/RestartIcon';
import useResetTimerButton from './vm';

export interface ResetTimerButtonProps extends DistributiveOmit<ButtonProps, 'onClick'> {}

const ResetTimerButton = (props: ResetTimerButtonProps) => {
  const { handleClick, isTimerRunning } = useResetTimerButton();

  return (
    <Button
      {...props}
      iconOnly
      variant="text"
      color="error"
      size="xSmall"
      disabled={isTimerRunning}
      onClick={handleClick}
    >
      <RestartIcon size={32} color="inherit" />
    </Button>
  );
};

export default ResetTimerButton;
